// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsPlpPatientPatientLookupResponseModel {
    static getAttributeTypeMap() {
        return ScriptsPlpPatientPatientLookupResponseModel.attributeTypeMap;
    }
}
ScriptsPlpPatientPatientLookupResponseModel.discriminator = undefined;
ScriptsPlpPatientPatientLookupResponseModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "enrollments",
        "baseName": "enrollments",
        "type": "Array<HybridEnrollmentHistoryModel>"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    }
];
//# sourceMappingURL=scriptsPlpPatientPatientLookupResponseModel.js.map